export class ApiRequestError extends Error {
  constructor(message, options = {}) {
    super(message);
    this.name = "ApiRequestError";
    this.status = options.status || null;
    this.url = options.url || "";
    this.cause = options.cause || null;
  }
}

export function normalizeApiError(error, url) {
  const status = error?.response?.status || null;
  const fallbackMessage = "Icerik servisine baglanirken bir sorun olustu.";
  const message =
    error?.response?.data?.message ||
    error?.message ||
    fallbackMessage;

  return new ApiRequestError(message, {
    status,
    url,
    cause: error,
  });
}
